class WageAdvanceInfoController {

  constructor($window) {
    'ngInject';
    this.window = $window;
  }

  toggleInfo() {
    if(this.showInfo) this.window.scrollTo(0, 0);
    this.showInfo = !this.showInfo;    
  }

}

export default WageAdvanceInfoController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/wageAdvance/wageAdvanceInfo/wageAdvanceInfo.controller.js